import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

/**
 * Componente per gestire gli elementi trascinabili nella lista degli esercizi
 * 
 * @param {Object} props
 * @param {string} props.id - ID univoco per l'elemento
 * @param {React.ReactNode} props.children - I contenuti dell'elemento (il primo figlio deve essere la maniglia di drag)
 * @param {string} props.className - Classi CSS aggiuntive da applicare
 */
export function SortableExerciseItem({ id, children, className }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={className}
    >
      {/* Il primo elemento è la maniglia di drag, gli altri sono i contenuti normali */}
      {React.Children.map(children, (child, index) => {
        if (index === 0) {
          // Solo il primo elemento (la maniglia) riceve gli attributi di dragging
          return React.cloneElement(child, {
            ...attributes,
            ...listeners,
            style: { cursor: 'grab' }
          });
        }
        return child;
      })}
    </div>
  );
}